import cn from "classnames"
import React, { useEffect, useState } from "react"

// import Facebook from "../assets/facebook.react.svg"
import Max from "../assets/max.react.svg"
import Telegram from "../assets/telegram.react.svg"
import Vk from "../assets/vk.react.svg"
import styles from "./index.module.css"

type SocialLinksProps = {
  className?: string
}

export const SocialShare: React.FC<SocialLinksProps> = ({ className }) => {
  const [href, setHref] = useState<string>("")

  useEffect(() => {
    setHref(location.href)
  }, [])

  return (
    <div className={className}>
      <a
        className={cn(styles.Item, styles.ItemMax)}
        href={`https://max.ru/:share?text=${encodeURIComponent(href)}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Max />
      </a>

      {/* <a
        className={styles.Item}
        href={`https://www.facebook.com/sharer.php?u=${href}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Facebook />
      </a> */}

      <a
        className={styles.Item}
        href={`https://t.me/share/url?url=${href}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Telegram />
      </a>

      <a
        className={styles.Item}
        href={`https://vk.com/share.php?url=${href}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Vk />
      </a>
    </div>
  )
}
